export default __webpack_public_path__ + "static/media/osariemen.31a95634.png";